import { render, staticRenderFns } from "./ItDriverPerformance.vue?vue&type=template&id=48f262f3&scoped=true"
import script from "./ItDriverPerformance.vue?vue&type=script&lang=ts"
export * from "./ItDriverPerformance.vue?vue&type=script&lang=ts"
import style0 from "./ItDriverPerformance.vue?vue&type=style&index=0&id=48f262f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f262f3",
  null
  
)

export default component.exports